let locales = {
    agetn_configNotications_create_admin: 'Abilita  le notifiche per la creazione di note (amministratori)',
    agetn_configNotications_modificate_admin: 'Abilita le notifiche per la modifica delle note (amministratori)',
    agetn_configNotications_delete_admin: 'Abilita le notifiche per la cancellazione delle note (amministratori)',
    agetn_configNotications_create_agent: 'Abilita le notifiche per la creazione di note (agenti)',
    agetn_configNotications_modificate_agent: 'Abilita le notifiche per la modifica delle note (agenti)',
    agetn_configNotications_delete_agent: 'Attiva le notifiche per l`eliminazione della nota (agente)',
   
};
export default locales;